import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a09e1bae&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09e1bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a09e1bae')) {
      api.createRecord('a09e1bae', component.options)
    } else {
      api.reload('a09e1bae', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a09e1bae&scoped=true&", function () {
      api.rerender('a09e1bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ONb6DXVG6hpj/JS/comp/Accordion.vue"
export default component.exports